import Footer from "../Footer";
const DashboardFooter = () => {
    return ( <Footer/> );
}
 
export default DashboardFooter;